export default {
  current: state => state.items.slice(-1)[0],
};
